if (!customElements.get('dedra-shirt-selector')) {
  customElements.define('dedra-shirt-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = JSON.parse(this.querySelector('[data-selector-config]').textContent);
      this.labels = this.config.labels;
      this.form = this.querySelector('form');
      this.idInput = this.querySelector('[data-variant-id]');
      this.brand = this.querySelector('[data-brand]');
      this.size = this.querySelector('[data-size]');
      this.color = this.querySelector('[data-color]');
      this.placement = this.querySelector('[data-placement]');
      this.chart = this.querySelector('[data-shirt-chart]');
      this.quantity = this.querySelector('[data-quantity]');
      this.button = this.querySelector('[data-submit]');
      this.status = this.querySelector('[data-status]');
      this.total = this.querySelector('[data-total]');
      this.mode = 'transfer';
      this.sequence = 0;
      this.querySelector('[data-enhanced]').hidden = false;
      this.querySelectorAll('[name=dedra_purchase_type]').forEach(input => {
        input.addEventListener('change', () => this.setMode(input.value));
      });
      this.brand?.addEventListener('change', () => this.loadShirt('brand'));
      this.size?.addEventListener('change', () => this.loadShirt('size'));
      this.color?.addEventListener('change', () => this.loadShirt('color'));
      this.form.addEventListener('submit', event => this.addToCart(event));
      this.setMode('transfer');
    }

    disconnectedCallback() {
      this.request?.abort();
    }

    setStatus(message = '', error = false) {
      this.status.textContent = message;
      this.status.dataset.error = String(error);
    }

    setMode(mode) {
      this.request?.abort();
      this.sequence++;
      this.loading = false;
      this.removeAttribute('aria-busy');
      this.mode = mode;
      const shirt = mode === 'shirt';
      this.querySelector('[data-shirt-fields]').hidden = !shirt;
      const price = document.getElementById(`price-${this.dataset.sectionId}`);
      if (price) price.hidden = shirt;
      this.querySelectorAll('[data-shirt-property]').forEach(input => { input.disabled = !shirt; });
      if (this.placement) {
        this.placement.disabled = !shirt;
        this.placement.required = shirt;
      }
      if (this.brand) {
        this.brand.disabled = !shirt;
        this.brand.required = shirt;
      }
      if (this.size) this.size.disabled = !shirt || !this.brand.value;
      if (this.color) this.color.disabled = !shirt || !this.size.value;
      this.quantity.removeAttribute('max');
      this.setStatus();
      if (!shirt) {
        this.idInput.value = this.config.transfer.id;
        this.querySelector('[data-submit-label]').textContent = this.labels.addTransfer;
        this.button.disabled = !this.config.transfer.available;
        if (this.size) this.size.required = false;
        if (this.color) this.color.required = false;
        if (!this.config.transfer.available) this.setStatus(this.labels.unavailable);
      } else {
        this.querySelector('[data-submit-label]').textContent = this.labels.addShirt;
        this.button.disabled = true;
        this.idInput.value = '';
        if (this.size) this.size.required = true;
        if (this.color) this.color.required = true;
        if (this.brand?.value && this.size?.value && this.color?.value) this.loadShirt('color');
        else if (this.brand?.value && this.size?.value) this.loadShirt('size');
        else if (this.brand?.value) this.loadShirt('brand');
      }
    }

    fillSelect(select, values, placeholder) {
      select.replaceChildren(new Option(placeholder, ''));
      for (const value of values.filter(item => item.available)) {
        select.add(new Option(value.label, String(value.id)));
      }
      select.disabled = false;
    }

    async loadShirt(stage) {
      this.request?.abort();
      const sequence = ++this.sequence;
      this.loading = false;
      this.removeAttribute('aria-busy');
      this.variant = null;
      this.idInput.value = '';
      this.button.disabled = true;
      this.total.textContent = this.labels.choosePrice;
      this.quantity.removeAttribute('max');
      this.setStatus();
      if (stage === 'brand') {
        if (this.chart) {
          const choice = this.brand.selectedOptions[0];
          const chartUrl = choice?.dataset.chartUrl;
          this.chart.hidden = !chartUrl;
          this.chart.open = false;
          const image = this.chart.querySelector('[data-chart-image]');
          if (chartUrl) {
            this.chart.querySelector('[data-chart-link]').href = chartUrl;
            image.src = chartUrl;
            image.width = Number(choice.dataset.chartWidth) || 1224;
            image.height = Number(choice.dataset.chartHeight) || 1600;
          } else {
            image.removeAttribute('src');
            this.chart.querySelector('[data-chart-link]').removeAttribute('href');
          }
          const secondaryLink = this.chart.querySelector('[data-chart-link-secondary]');
          if (secondaryLink) {
            const secondaryImage = secondaryLink.querySelector('[data-chart-image-secondary]');
            const secondaryUrl = choice?.dataset.chartUrl2;
            secondaryLink.hidden = !secondaryUrl;
            if (secondaryUrl) {
              secondaryLink.href = secondaryUrl;
              secondaryImage.src = secondaryUrl;
              secondaryImage.width = Number(choice.dataset.chartWidth2) || 1224;
              secondaryImage.height = Number(choice.dataset.chartHeight2) || 1584;
            } else {
              secondaryLink.removeAttribute('href');
              secondaryImage.removeAttribute('src');
            }
          }
        }
        this.size.replaceChildren();
        this.color.replaceChildren();
        this.querySelector('[data-size-field]').hidden = true;
        this.querySelector('[data-color-field]').hidden = true;
      } else if (stage === 'size') {
        this.color.replaceChildren();
        this.querySelector('[data-color-field]').hidden = true;
      }
      this.size.disabled = true;
      this.color.disabled = true;
      if (!this.brand.value || (stage !== 'brand' && !this.size.value) || (stage === 'color' && !this.color.value)) {
        this.size.disabled = !this.size.options.length;
        this.color.disabled = !this.color.options.length;
        return;
      }
      this.request = new AbortController();
      this.loading = true;
      this.setAttribute('aria-busy', 'true');
      this.setStatus(this.labels.loading);
      try {
        const url = new URL(this.brand.value, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid product URL');
        url.searchParams.set('section_id', 'dedra-shirt-data');
        const options = [];
        if (stage !== 'brand') options.push(this.size.value);
        if (stage === 'color') options.push(this.color.value);
        if (options.length) url.searchParams.set('option_values', options.join(','));
        const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewId) url.searchParams.set('preview_theme_id', previewId);
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Product data unavailable');
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = document.querySelector('[data-dedra-shirt-data]');
        if (!content) throw new Error('Missing product data');
        const data = JSON.parse(content.textContent);
        if (sequence !== this.sequence || this.mode !== 'shirt') return;
        if (!data.configured) {
          this.setStatus(this.labels.configurationError, true);
          return;
        }
        this.setStatus();
        if (stage === 'brand') {
          this.fillSelect(this.size, data.sizes, this.labels.chooseSize);
          this.querySelector('[data-size-field]').hidden = false;
          if (this.size.options.length === 1) this.setStatus(this.labels.unavailable);
        } else if (stage === 'size') {
          this.fillSelect(this.color, data.colors, this.labels.chooseColor);
          this.querySelector('[data-color-field]').hidden = false;
          if (this.color.options.length === 1) this.setStatus(this.labels.unavailable);
        } else {
          const size = data.sizes.find(value => String(value.id) === this.size.value);
          const color = data.colors.find(value => String(value.id) === this.color.value);
          const variant = data.variant;
          if (!size?.available || !color?.available || !variant?.available || !variant.tracked || variant.quantity < 1 || variant.priceCents <= 0) {
            this.setStatus(this.labels.unavailable, true);
            return;
          }
          this.variant = variant;
          this.idInput.value = variant.id;
          this.total.textContent = `${this.labels.pricePrefix} ${variant.price}`;
          this.querySelector('[data-brand-property]').value = data.title;
          this.querySelector('[data-size-property]').value = size.label;
          this.querySelector('[data-color-property]').value = color.label;
          this.quantity.max = variant.quantity;
          if (Number(this.quantity.value) > variant.quantity) this.quantity.value = variant.quantity;
          this.button.disabled = false;
        }
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) this.setStatus(this.labels.loadError, true);
      } finally {
        if (sequence === this.sequence) {
          this.loading = false;
          this.removeAttribute('aria-busy');
          this.size.disabled = !this.size.options.length;
          this.color.disabled = !this.color.options.length;
        }
      }
    }

    async addToCart(event) {
      event.preventDefault();
      if (this.submitting || this.loading) return;
      if (this.mode === 'shirt' && (!this.variant || !this.brand.value || !this.size.value || !this.color.value)) {
        this.setStatus(this.labels.selectRequired, true);
        return;
      }
      if (this.mode === 'shirt' && !['Front of shirt', 'Back of shirt'].includes(this.placement?.value)) {
        this.setStatus(this.labels.choosePlacementError, true);
        this.placement?.focus();
        return;
      }
      if (!this.form.reportValidity()) return;
      if (this.mode === 'transfer' && !this.config.transfer.available) return;
      const formData = new FormData(this.form);
      formData.delete('dedra_purchase_type');
      formData.set('id', this.mode === 'shirt' ? this.variant.id : this.config.transfer.id);
      this.submitting = true;
      this.button.disabled = true;
      this.querySelectorAll('[name=dedra_purchase_type]').forEach(input => { input.disabled = true; });
      [this.brand, this.size, this.color, this.placement].filter(Boolean).forEach(input => { input.disabled = true; });
      this.setStatus(this.labels.adding);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.labels.cartError);
        window.location.assign(`${root}cart`);
      } catch (error) {
        this.setStatus(error.message || this.labels.cartError, true);
        this.submitting = false;
        this.querySelectorAll('[name=dedra_purchase_type]').forEach(input => { input.disabled = false; });
        if (this.mode === 'shirt') {
          this.brand.disabled = false;
          this.size.disabled = false;
          this.color.disabled = false;
          this.placement.disabled = false;
        }
        this.button.disabled = false;
      }
    }
  });
}
